import { render } from "./LocationDocumentsSettings.vue?vue&type=template&id=44e46b8c&scoped=true"
import script from "./LocationDocumentsSettings.vue?vue&type=script&lang=js"
export * from "./LocationDocumentsSettings.vue?vue&type=script&lang=js"

import "./LocationDocumentsSettings.vue?vue&type=style&index=0&id=44e46b8c&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e46b8c"]])

export default __exports__